import {
  AddPage,
  EditPage,
  TablePage,
  ViewPage,
} from 'src/views/logisticsadmin/jsonschema'

import pathMap from 'src/paths/PathMap_LogisticsAdmin'

class JsonSchemaRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.JSON_SCHEMA_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.JSON_SCHEMA_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.JSON_SCHEMA_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.JSON_SCHEMA_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default JsonSchemaRoute
